export const Button = ({ children, ...props }) => {
    return (
      <button
        disabled={props.isSubmitting}
        className={`tw-text-white  tw-w-full tw-h-12 tw-rounded-lg tw-mt-6 tw-bg-green-400 tw-font-bold tw-text-lg`}
        type="submit"
      >
        {children}
      </button>
    );
  };
  